import api from './api';

export interface ActionStatistics {
    count: number;
}

class ActionStatisticsService {
    async getPlannedActions(): Promise<ActionStatistics> {
        try {
            const response = await api.get('api/plano-acao/estatisticas/planejadas');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ações planejadas:', error);
            throw error;
        }
    }

    async getNotStartedActions(): Promise<ActionStatistics> {
        try {
            const response = await api.get('api/plano-acao/estatisticas/nao-iniciadas');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ações não iniciadas:', error);
            throw error;
        }
    }

    async getInProgressActions(): Promise<ActionStatistics> {
        try {
            const response = await api.get('api/plano-acao/estatisticas/em-andamento');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ações em andamento:', error);
            throw error;
        }
    }

    async getCompletedActions(): Promise<ActionStatistics> {
        try {
            const response = await api.get('api/plano-acao/estatisticas/concluidas');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ações concluídas:', error);
            throw error;
        }
    }

    async getCancelledActions(): Promise<ActionStatistics> {
        try {
            const response = await api.get('api/plano-acao/estatisticas/canceladas');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ações canceladas:', error);
            throw error;
        }
    }
}

export const actionStatisticsService = new ActionStatisticsService();
